<template>

    <section class="section main">
      <div class="container has-text-centered ">
        <h2 v-html="$t('profile.OSRMammalStatus.introSection.title', { sppName: state?.sppName })"></h2>
        <div class="condensed bold richtext" v-html="$t('profile.OSRMammalStatus.introSection.description', { sppName: state?.sppName })"></div>
        <h4>{{ $t("profile.ABStatus.sectionIntroLead") }} </h4>
        <p>
          <a :href="profilePageUrl + '#' + 'methods'" class="button is-primary">
            {{ $t('profile.OSRMammalStatus.methodSection.header') }}
          </a>
          <template v-for="(section, index) in sections" :key="'OSRMammalStatus' + index">
            <a :href="profilePageUrl + '#' + section" class="button is-primary">
              {{ $t("profile.OSRMammalStatus." + section + ".sectionHeaderButton") }}
            </a>
          </template>
        </p>
      </div>
    </section>
    <section class="section main pretty-top bgLight pretty-bottom" id = 'methods'>
      <div class="container">
        <div class="columns">
          <div class="column">
            <h2 class=" has-text-centered">{{ $t('profile.OSRMammalStatus.methodSection.header') }}</h2>
            <div class="columns is-multiline is-centered">
              <div class="column is-6-tablet">
                <div :class="{'collapsed': !showFullContent}" class="i18n" v-html="methodsContentLeft"></div>
              </div>
              <div class="column is-6-tablet">
                <div :class="{'collapsed': !showFullContent}"  class="i18n" v-html="methodsContentRight"></div>
              </div>
            </div>
            <button v-if="showReadmore" @click="toggleMethods" class="no-border">{{ showFullContent ? '...Read Less' : '...Read More' }}</button>
          </div>
        </div>
      </div>
    </section>

</template>
<script setup>
import { osrMammalTabSections as sections } from '@/config/profile-config';
import { useApp } from '@/composables/state/profileState';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
const { profilePageUrl, state } = useApp();
const { t } = useI18n();
const showReadmore = ref(false);
const showFullContent = ref(true);
const methodsContentLeft = t('profile.OSRMammalStatus.methodSection.leftColumn');
const methodsContentRight = t('profile.OSRMammalStatus.methodSection.rightColumn');

const toggleMethods = () => {
  showFullContent.value = !showFullContent.value;
};

</script>

<style scoped>
@import "../ABStatus/status-intro.css";

.container >>> ol li {
  list-style: inside decimal;
  padding-left: 1.2em;
  text-indent: -1.2em;
}
.no-border {
  border: none;
  background-color: #f6f6f6;
  cursor: pointer;
  font-weight: bold;
  font-style: italic;
  font-size: 17px;
}
.i18n >>> p {
  margin: 0.3rem 0;
}
.collapsed {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box!important;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  white-space: normal;
}
</style>
